import { useState } from 'react';
import { useIsomorphicLayoutEffect } from '@shared/utils/hooks/useIsomorphicLayoutEffect';

// Presence follows the longest track, not an opacity threshold. Reopening cancels teardown.
export const useDialogMotionPresence = (isOpen: boolean, enabled: boolean, exitDuration: number): boolean => {
  const [present, setPresent] = useState(isOpen && enabled);
  useIsomorphicLayoutEffect(() => {
    if (!enabled || (!isOpen && exitDuration === 0)) {
      setPresent(false);
      return;
    }
    if (isOpen) {
      setPresent(true);
      return;
    }
    const timeout = setTimeout(() => setPresent(false), exitDuration);
    return () => clearTimeout(timeout);
  }, [enabled, isOpen, exitDuration]);
  return enabled && present;
};
